<template>
  <div>
    <top-header v-bind:title="$t('subjects')">
      <header-button icon="mdi-plus-box"
                     right
                     slot="right-button"
                     v-bind:label="$t('add')"
                     v-bind:to="{ name: 'learning-subject-add' }" />
    </top-header>
    <v-container>
      <subject-table-card item-route-name="learning-subject"
                          v-bind:loading="loading"
                          v-bind:subjects="subjects" />
    </v-container>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  import HeaderButton from '@/components/common/HeaderButton.vue'
  import TopHeader from '@/components/common/TopHeader.vue'
  import SubjectTableCard from '@/components/learning/SubjectTableCard.vue'

  export default {
    components: {
      HeaderButton,
      SubjectTableCard,
      TopHeader
    },
    computed: {
      ...mapGetters({
        subjects: 'learning/subjects'
      })
    },
    async created() {
      this.loading = true

      await this.loadSubjects()

      this.loading = false
    },
    data: () => ({
      loading: false
    }),
    methods: {
      ...mapActions({
        loadSubjects: 'learning/loadSubjects'
      })
    },
    name: 'Subjects'
  }
</script>

<i18n>
  {
    "de": {
      "add": "Neu",
      "subjects": "Module"
    },
    "en": {
      "add": "Add",
      "subjects": "Subjects"
    }
  }
</i18n>